/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ws (ignored)
// module id = 3
// module chunks = 0 1 2